import React from 'react';
import { dashboardCustomizeConstants } from './constants';
import DashboardCustomWidget1 from './DashboardCustomWidget1';
import DashboardCustomWidget2 from './DashboardCustomWidget2';
import DashboardCustomWidget4 from './DashboardCustomWidget4';

const DashboardCustomPreview = ({ usingWidgets, isActive, ...props }) => {
  if (!usingWidgets.length) {
    return <div className="preview-section"></div>;
  }

  return (
    <div className="preview-section">
      {usingWidgets.map((widget) => {
        return (
          <React.Fragment key={widget.id}>
            {widget.terminateRow ? <hr className="--break-line" /> : null}
            {{
              [dashboardCustomizeConstants.widget2]: (
                <DashboardCustomWidget2
                  key={widget.id}
                  values={widget}
                  updateShouldDisplayCMV={props.updateShouldDisplayCMV}
                  shouldDisplayCMV={props.shouldDisplayCMV}
                  isActive={isActive}
                />
              ),
              [dashboardCustomizeConstants.widget4]: (
                <DashboardCustomWidget4
                  key={widget.id}
                  values={widget}
                  isActive={isActive}
                />
              ),
            }[widget.widgetTypeName] || (
              <DashboardCustomWidget1
                key={widget.id}
                values={widget}
                isActive={isActive}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default DashboardCustomPreview;
